import { render, staticRenderFns } from "./ElTooltip.vue?vue&type=template&id=ee038288"
import script from "./ElTooltip.vue?vue&type=script&lang=js"
export * from "./ElTooltip.vue?vue&type=script&lang=js"
import style0 from "./ElTooltip.vue?vue&type=style&index=0&id=ee038288&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports